import './AnnualLeave.scss';
import { Outlet } from 'react-router-dom';

const AnnualLeave = () => {
  return (
    <div>
      <h2>Annual Leave</h2>
      <Outlet />
    </div>
  );
};

export default AnnualLeave;
